import { Link } from "@material-ui/core";
import React from "react";

import { Helmet } from "react-helmet";

const SeoHelmet = ({
  title,
  description,
  url,
  ogType = "website",
  schemaJson,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {schemaJson && (
        <script type="application/ld+json">{JSON.stringify(schemaJson)}</script>
      )}
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />

      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SeoHelmet;
